import Cookies from "js-cookie";

/**
 * Creates a cookie that expires in 20 years.
 * @param cookieName The name of the cookie.
 * @param value The value of the cookie.
 */
export function setPermanentCookie(cookieName, value) {
  Cookies.set(cookieName, value, { expires: 365 * 20 });
}